import { FsApiService } from '@/app/services/auth/fs-api.service';
import { TranslationService } from '@/app/services/translation.service';
import { inject, Injectable, signal } from '@angular/core';
import { catchError, of } from 'rxjs';
import { ITeamsStandingsApi } from '../models';

@Injectable({
  providedIn: 'root',
})
export class TeamStandingsService {
  private fsApi = inject(FsApiService);
  private translationService = inject(TranslationService);

  isLoadingTeamsStandings = signal<boolean>(false);
  isErrorTeamsStandings = signal<boolean>(false);
  teamsStandings = signal<ITeamsStandingsApi | null>(null);

  constructor() {}

  getTeamStandings(teamId: string) {
    this.isLoadingTeamsStandings.set(true);
    this.isErrorTeamsStandings.set(false);

    this.fsApi
      .get<ITeamsStandingsApi | null>(`/teams/${teamId}/standings`)
      .pipe(
        catchError((_) => {
          this.isLoadingTeamsStandings.set(false);
          this.isErrorTeamsStandings.set(true);

          return of(null);
        })
      )
      .subscribe((data) => {
        if (!data) {
          this.isLoadingTeamsStandings.set(false);
          this.teamsStandings.set(null);
          return;
        }

        const newData = data as ITeamsStandingsApi;

        const stageStandings = newData.StageStandings ?? [];

        newData.StageStandings = stageStandings.map((standing) => {
          const groupStandings = standing.GroupStandings ?? [];

          return {
            ...standing,
            GroupStandings: groupStandings.map((groupStanding) => {
              const teams = groupStanding.Teams ?? [];

              return {
                ...groupStanding,
                Teams: teams.map((team) => ({
                  ...team,
                  Link: this.translationService.getTraslateUrlTeamDetails(
                    team.NameTranslation ?? {},
                    team.Name,
                    team.Id
                  ),
                })),
              };
            }),
          };
        });

        // if (newData.Standings) {
        //   newData.Standings = newData.Standings.map((standing) => {
        //     if (!standing.Teams) {
        //       return {
        //         ...standing,
        //         Teams: [],
        //       };
        //     } else {
        //       return {
        //         ...standing,
        //         Teams: standing.Teams.map((team) => ({
        //           ...team,
        //           Link: this.translationService.getTraslateUrlTeamDetails(
        //             team.NameTranslation ?? {},
        //             team.Name,
        //             team.Id
        //           ),
        //         })),
        //       };
        //     }
        //   });
        // }

        this.isLoadingTeamsStandings.set(false);
        this.teamsStandings.set(newData);
      });
  }
}
